import { Pharmacy } from './patient';

export interface IntakeForm {
  completeDateTime: string; // ISO 8601 format
  intakeFormId: string;
  isPrepopulated: boolean;
  name: string;
  questions: Question[];
  visitId: string;
}

export enum QuestionType {
  BODY_MEASUREMENT = 'bodymeasurement',
  CONDITION = 'condition',
  EMAIL = 'email',
  FILE = 'file',
  OPTION = 'option',
  STATEMENT = 'statement',
  TEXTBOX = 'textbox',
  PHARMACY_SELECTION = 'pharmacyselection',
}

export type Question =
  | BodyMeasurementQuestion
  | ConditionQuestion
  | EmailQuestion
  | FileQuestion
  | OptionQuestion
  | StatementQuestion
  | TextboxQuestion
  | PharmacyQuestion;

interface QuestionBase {
  intakeFormQuestionId: string;
  isRequired: boolean;
  question: string | null;
}

export interface BodyMeasurementQuestion extends QuestionBase {
  heightInches: number | null;
  weightPounds: number | null;
  question: null;
  type: QuestionType.BODY_MEASUREMENT;
}

export interface ConditionQuestion extends QuestionBase {
  options: ConditionOption[];
  question: string;
  type: QuestionType.CONDITION;
}

export interface ConditionOption {
  input: {
    isRequired: boolean;
    value: string | null;
  } | null;
  isSelected: boolean;
  name: string;
}

export interface EmailQuestion extends QuestionBase {
  email: string | null;
  question: string;
  type: QuestionType.EMAIL;
}

export interface FileQuestion extends QuestionBase {
  files: FileInfo[];
  fileTypes: string[];
  question: string;
  text: string | null;
  type: QuestionType.FILE;
}

export interface FileInfo {
  fileId: string;
  name: string;
  uploadDateTime: string; // ISO 8601 format
  url: string;
}

export interface OptionQuestion extends QuestionBase {
  isMultipleAnswerAllowed: boolean;
  options: Option[];
  question: string;
  type: QuestionType.OPTION;
}

export interface Option {
  isSelected: boolean;
  name: string;
}

export interface StatementQuestion extends QuestionBase {
  question: string;
  type: QuestionType.STATEMENT;
}

export interface TextboxQuestion extends QuestionBase {
  question: string;
  text: string | null;
  type: QuestionType.TEXTBOX;
}
export interface PharmacyQuestion extends QuestionBase, Pharmacy {
  question: string;
  type: QuestionType.PHARMACY_SELECTION;
  updated?: boolean;
}
